{
  "Add to Calendar": "Add to Calendar",
  "All times are shown in {{timezoneAbbr}}. You can select up to 3 time slots that fit in your schedule, and we’ll reach out to you to confirm.": "All times are shown in {{timezoneAbbr}}. You can select up to 3 time slots that fit in your schedule, and we’ll reach out to you to confirm.",
  "An email confirmation has been sent to": "An email confirmation has been sent to",
  "An unexpected error occurred.": "An unexpected error occurred.",
  "Any Provider (No preference)": "Any Provider (No preference)",
  "Any provider (no preference)": "Any provider (no preference)",
  "Appointment Booked": "Appointment Booked",
  "Back": "Back",
  "Book Another Appointment": "Book Another Appointment",
  "Booking progress": "Booking progress",
  "Call or text us at": "Call or text us at",
  "Call the Practice": "Call the Practice",
  "Cancellation Policy": "Cancellation Policy",
  "Continue": "Continue",
  "Date and Time": "Date and Time",
  "Date and time": "Date and time",
  "Location": "Location",
  "Next Available": "Next Available",
  "Next availability:": "Next availability:",
  "Next available: ": "Next available: ",
  "No openings available from {{calendarStartDate}} to {{calendarEndDate}}": "No openings available from {{calendarStartDate}} to {{calendarEndDate}}",
  "No times have been selected": "No times have been selected",
  "Or select a specific provider": "Or select a specific provider",
  "Patient information": "Patient information",
  "Payment": "Payment",
  "Payment Received": "Payment Received",
  "Provider": "Provider",
  "Questions about your request?": "Questions about your request?",
  "Request Appointment": "Request Appointment",
  "Request to book": "Request to book",
  "Requested Date and Time": "Requested Date and Time",
  "Requested Provider": "Requested Provider",
  "Requested Service": "Requested Service",
  "Requested times": "Requested times",
  "Scheduling powered by": "Scheduling powered by",
  "Select a date": "Select a date",
  "Select a location": "Select a location",
  "Select a provider": "Select a provider",
  "Select a time for {{selectedDate}}": "Select a time for {{selectedDate}}",
  "Service": "Service",
  "Service Type": "Service Type",
  "Something went wrong on our end and your appointment was not booked.": "Something went wrong on our end and your appointment was not booked.",
  "Start Over": "Start Over",
  "We couldn't complete your booking.": "We couldn't complete your booking.",
  "We’ll confirm shortly": "We’ll confirm shortly",
  "What can we help you with?": "What can we help you with?",
  "You were away for a bit, so we ended your session. Nothing was saved.": "You were away for a bit, so we ended your session. Nothing was saved.",
  "You will be sent a confirmation SMS to": "You will be sent a confirmation SMS to",
  "You're almost there, {{locationName}} will get back to you to confirm your appointment": "You're almost there, {{locationName}} will get back to you to confirm your appointment",
  "Your session has expired": "Your session has expired",
  "pages": "pages",
  "{{amount}} received for {{serviceName}}": "{{amount}} received for {{serviceName}}"
}
